<template>
    <b-container>
        <b-row align-h="center">
            <b-col cols="12" class="pb-md-4 pt-4 pb-2">
                <b-card class="shadow">
                    <h4 class="text-center text-primary text-uppercase">
                        <u>Transacción: ID {{ details.id }}</u>
                    </h4>
                    <h5 class="text-center">Estado: {{ details.status_text }}</h5>
                    <h6 class="text-center">Codigo: {{ details.int_id }}</h6>
                </b-card>
            </b-col>
        </b-row>
        <b-row align-h="center" align-v="stretch" v-if="refund && details.status === 110">
            <b-col cols="12" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Respuesta Reversión</b-th>
                                <b-td stacked-heading="Tipo">{{ refund.type }}</b-td>
                                <b-td stacked-heading="Valor Devuelto">{{ Number(refund.amount).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Código de Respuesta">({{ refund.response_code }}) Proceso {{ refund.response_text }}</b-td>
                                <b-td stacked-heading="Código Autorización">{{ refund.authorization_code }}</b-td>
                                <b-td stacked-heading="Fecha Autorización">{{ new Date((''+refund.authorization_date).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
        </b-row>
        <b-row align-h="center" align-v="stretch">
            <b-col cols="12" md="6" class="pb-md-4 py-2" v-if="user.role === 'Administrator' || user.role === 'Partner' || user.role === 'Cashier'">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Datos del Enviador</b-th>
                                <b-td stacked-heading="Nombres">{{ details.sender?.name }}</b-td>
                                <b-td stacked-heading="Apellidos">{{ details.sender?.lname ? (details.sender.lname).replace(',', '') : '' }}</b-td>
                                <b-td stacked-heading="Documento">{{ details.sender?.td }} {{ details.sender?.nd }}</b-td>
                                <b-td stacked-heading="Email">{{ details.sender?.email }}</b-td>
                                <b-td stacked-heading="Teléfono">{{ details.sender?.mobile }}</b-td>
                                <b-td stacked-heading="Dirección">{{ details.sender?.address }} {{ details.sender?.district }}</b-td>
                                <b-td stacked-heading="Ciudad">{{ details.sender?.city }}</b-td>
                                <b-td stacked-heading="País">{{ details.country_send_text }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Datos del Destinatario</b-th>
                                <b-td stacked-heading="Nombres">{{ details.receiver?.name }}</b-td>
                                <b-td stacked-heading="Apellidos">{{ details.receiver?.lname ? (details.receiver.lname).replace(',', '') : '' }}</b-td>
                                <b-td stacked-heading="Documento">{{ details.receiver?.td }} {{ details.receiver?.nd }}</b-td>
                                <b-td stacked-heading="Email">{{ details.receiver?.email }}</b-td>
                                <b-td stacked-heading="Teléfono">{{ details.receiver?.mobile }}</b-td>
                                <b-td stacked-heading="Dirección">{{ details.receiver?.address }} {{ details.receiver?.district }}</b-td>
                                <b-td stacked-heading="Ciudad">{{ details.receiver?.city }}</b-td>
                                <b-td stacked-heading="País">{{ details.country_receiver_text }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2" v-if="user.role === 'Administrator' && pay">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Detalles Pago con Tarjeta</b-th>
                                <b-td stacked-heading="Estado" v-if="pay.status">{{ pay.status }}</b-td>
                                <b-td stacked-heading="Fecha/Hora" v-if="pay.transaction_date">{{ new Date((''+pay.transaction_date).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}</b-td>
                                <b-td stacked-heading="Cuotas" v-if="pay.installments_number">{{ pay.installments_number + ' de $' + Number(pay.installments_amount).toLocaleString("en-US") }}</b-td>
                                <b-td stacked-heading="Tipo de Pago" v-if="pay.payment_type_text">{{ pay.payment_type_text }}</b-td>
                                <b-td stacked-heading="Número de Tarjeta" v-if="pay.card_number">{{ '**** **** **** ' + pay.card_number }}</b-td>
                                <b-td stacked-heading="Código Autorización" v-if="pay.authorization_code">{{ pay.authorization_code }}</b-td>
                                <b-td stacked-heading="Código de Respuesta" v-if="pay.response_text">{{ pay.response_text }}</b-td>
                                <b-td stacked-heading="Token" v-if="pay.token">{{ pay.token }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Detalles Pago Enviador</b-th>
                                <b-td stacked-heading="Sessión ID">{{ details.session_id }}</b-td>
                                <b-td stacked-heading="Fecha/Hora">{{ new Date((''+details.date).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}</b-td>
                                <b-td stacked-heading="Tipo de Pago">{{ details.payment_text }}</b-td>
                                <b-td stacked-heading="Valor Enviado">{{ Number(details.amount_send - details.fee).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Comisión">{{ Number(details.fee_net).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="IVA">{{ Number(details.tax).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Valor Pagado">{{ Number(details.amount_send).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Tasa de Conversión">{{details.rate < 1 ? Number(1/details.rate).toLocaleString("en-US", {maximumFractionDigits: 4}) : 1 }} {{ details.currency_send }} ► {{details.rate > 1 ? Number(details.rate).toLocaleString("en-US", {maximumFractionDigits: 4}) : 1 }} {{ details.currency_receiver }}</b-td>
                                <b-td stacked-heading="Valor Recibido">{{ Number(details.amount_receiver).toLocaleString("en-US") + ' ' + details.currency_receiver }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Detalles Pago Destinatario</b-th>
                                <b-td stacked-heading="Convenio" v-if="details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-')">{{ ((details.pin).split('-'))[0] }}</b-td>
                                <b-td stacked-heading="PIN">{{ details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-') ? ((details.pin).split('-'))[1] : details.pin }}</b-td>
                                <b-td stacked-heading="Banco" v-if="details.destiny_pay === 'Bank'">{{ details.bank_info?.name }}</b-td>
                                <b-td stacked-heading="Oficina" v-else>
                                    {{ details.office_info?.name ? (details.office_info.name + ' (' + details.office_info?.payer + ')') : '' }}
                                </b-td>
                                <b-td stacked-heading="Teléfono" v-if="details.destiny_pay === 'Cash'">{{ details.office_info?.phone }}</b-td>
                                <b-td stacked-heading="Dirección" v-if="details.destiny_pay === 'Cash'">{{ details.office_info?.address + ', ' + details.office_info?.city + (details.office_info?.state !== null ? ' - ' + details.office_info?.state : '') }}</b-td>
                                <b-td stacked-heading="Horario" v-if="details.destiny_pay === 'Cash'">{{ details.office_info?.open }}</b-td>
                                <b-td :stacked-heading="'Cuenta ' + (details.receiver.tc === 'Ahorros' ? 'de ' : '') + (details.receiver.tc ? details.receiver.tc : '')" v-else>{{ details.receiver.nc }}</b-td>
                                <b-td stacked-heading="CBU" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'AR'">{{ details.receiver.details?.cbu }}</b-td>
                                <b-td stacked-heading="CPF" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'BR'">{{ details.receiver.details?.cpf }}</b-td>
                                <b-td stacked-heading="Agencia Bancaria" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'BR'">{{ details.receiver.details?.nab }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2" v-if="user.role === 'Administrator'">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Información Interna</b-th>
                                <b-td stacked-heading="Corresponsal" v-if="details.payment === '0'">{{ details.partner }}</b-td>
                                <b-td stacked-heading="Verificador/Cajero" v-if="details.checker">{{ details.checker }}</b-td>
                                <b-td stacked-heading="Última Actualización">{{ new Date((''+details.update).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Details",
    props: [ 'user' ],
    data: () => ({
        loading: true,
        details: {
            id: '',
            int_id: '',
            pin: '',
            session_id: '',
            partner: '',
            checker: null,
            sender: {
                name: '',
                lname: '',
                td: '',
                nd: '',
                email: '',
                mobile: '',
                address: '',
                district: '',
                city: '',
                state: '',
                country: ''
            },
            receiver: {
                name: '',
                lname: '',
                td: '',
                nd: '',
                email: '',
                mobile: '',
                bank: '',
                tc: '',
                nc: '',
                address: '',
                district: '',
                city: '',
                state: '',
                country: ''
            },
            country_send_text: '',
            country_receiver_text: '',
            destiny_pay: '',
            office_info: {
                name: '',
                payer: ''
            },
            bank_info: {
                name: ''
            },
            amount_send: '',
            currency_send: '',
            fee: '',
            fee_text: '',
            fee_net: '',
            fee_net_text: '',
            tax: '',
            tax_text: '',
            tax_rate: 0,
            fx_rate: '',
            amount_receiver: '',
            currency_receiver: '',
            payment: '',
            payment_text: '',
            status_text: ''
        },
        pay: {
            token: null,
            vci: null,
            amount: null,
            status: null,
            session_id: null,
            card_number: null,
            accounting_date: null,
            transaction_date: null,
            authorization_code: null,
            payment_type_code: null,
            payment_type_text: null,
            response_code: null,
            response_text: null,
            installments_amount: null,
            installments_number: null,
            balance: null
        },
        refund: {
            type: null,
            amount: null,
            authorization_code: null,
            authorization_date: null,
            response_code: null,
            response_text: null,
            balance: null
        }
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'detailspage');
        this.details.id = this.$route.params.id;
        this.getIni();
    },
    watch: {
        'user.partner'() {
            clearTimeout(this.timeout);
            this.getIni();
        }
    },
    methods: {
        getIni() {
            let id = this.$route.params.id;
            axios.get('/api/customer/payments/' + id).then((res) => {
                if (res.data.status === 'success') {
                    this.details = res.data.details;
                    this.pay = res.data.pay;
                    this.refund = res.data.refund;
                } else {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (this.user.partner) {
                        this.$router.push({name: 'PartnerHistory'});
                    } else {
                        this.$router.push({name: 'History'});
                    }
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
            this.timeout = setTimeout(this.getIni, 180000);
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
